module.exports = __webpack_public_path__ + "../resources/images/illustration_draft-71ae70a358a78d4dcde2d551a2b037a5.svg";